import { AxInit, ModuleName } from "../../../Lib/AxSystem/AxInit";
import { ProductMapper } from "../../../Lib/Mapper/ProductMapper";
import { AxLimeStone } from "../../../Limestone/AxLimeStone";
import { IAddToCartRequest } from "../../../Models/Package/IAddToCartRequest";
import { AxProdNonPredateableInit, NonPreDateable } from "../Abstraction/NonPreDateable";

@ModuleName("AxPackNonPredateable")
export class AxPackNonPredateable extends NonPreDateable implements AxInit {
    private ProjNr: number;
    private TariffSheetNr: number;
    private PackageNr: number;

    constructor(private _ProductMapper = new ProductMapper(),
        private _AxLimestone = new AxLimeStone()) { super(); }

    AxInit(initData: AxProdNonPredateableInit): void {
        this.ProjNr = initData.ProjNr;
        this.TariffSheetNr = initData.ProductGroupIdentifier;
        this.PackageNr = initData.Id;

        $('.prod_selection__persontype-submit').on('click', e => {
            this._AxLimestone.LockButton(e.delegateTarget);
            this.ToSummary();
        });

        this.Init(initData);
    }

    ToSummary(): void {
        if (this._TicketList.ProductList.filter(x => x.Quantity > 0).length > 0) {
            let requestObj: IAddToCartRequest = {
                ProjNr: this.ProjNr,
                PackTariffSheetNo: this.TariffSheetNr,
                PackageNr: this.PackageNr,
                PackagePositions: this._ProductMapper.GetPackagePositionList(this._TicketList.ProductList),
                Date: moment().format('YYYY-MM-DD')
            };

            this._summaryRedirect.redirect(this.PostURL, requestObj, false);
        }
    }
}
